// extracted by mini-css-extract-plugin
export var divider = "dividerline-module--divider--fT8+H";